import script from "./TooltipProvider.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipProvider.vue?vue&type=script&setup=true&lang=js"

import "./TooltipProvider.vue?vue&type=style&index=0&id=4e5f8938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5f8938"]])

export default __exports__